module.exports = __webpack_public_path__ + "img/banner-r.583f4c6b.png";